import { render } from "./PacientesEnfermero.vue?vue&type=template&id=748d3b6b&scoped=true"
import script from "./PacientesEnfermero.vue?vue&type=script&lang=js"
export * from "./PacientesEnfermero.vue?vue&type=script&lang=js"

import "./PacientesEnfermero.vue?vue&type=style&index=0&id=748d3b6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748d3b6b"]])

export default __exports__